import { OptionCard, StepBody, StepHeader, StepNav } from "./HikvisionWizardParts";

const HikvisionStepOutput = ({ outputs, pinSelected, setPinSelected, onNext, onBack, isLastStep, lastStepLabel = "Link Hikvision" }) => (
    <>
        <StepHeader
            title="Which app output would you like to link the Hikvision to?"
            subtitle="Make sure the Hikvision and the selected output are in the same state. If they differ, the first command only syncs them and will NOT change the Hikvision."
        />
        <StepBody>
            {outputs.length === 0 && (
                <p style={{ color: "var(--text-label)", fontSize: "14px", textAlign: "center", marginTop: "2rem" }}>
                    No outputs are available to link.
                </p>
            )}
            {outputs.map(output => (
                <OptionCard
                    key={output.Pin}
                    radio
                    title={output.pinName}
                    selected={pinSelected === output.Pin}
                    onClick={() => setPinSelected(output.Pin)}
                />
            ))}
        </StepBody>
        <StepNav
            onBack={onBack}
            onNext={onNext}
            nextDisabled={pinSelected == null}
            nextLabel={isLastStep ? lastStepLabel : "Next"}
            nextIcon={isLastStep ? "pi pi-link" : "pi pi-arrow-right"}
        />
    </>
);

export default HikvisionStepOutput;
